import React from 'react'
import MediaCardComponent from '../MediaCard/MediaCardComponent'
import CONTENT from './content'

export default function PriceBreakersMediaCard() {
  return (
    <>
      <MediaCardComponent content={CONTENT} />
    </>
  )
}
